import React, { useState } from 'react';
import Layout from '../components/Layout/Layout';
import Datepicker from 'react-tailwindcss-datepicker';
//import { useTickets } from '../components/Products/Support/useTickets';
import TicketDetails from '../components/Products/Support/TicketDetails';
import Tickets from '../components/Products/Support/Tickets';
import { SupportProvider } from '../hoc/SupportContext';
import TicketTabs from '../components/Products/Support/TicketTabs';
import ProductList from '../components/Products/Support/ProductList';




const filter = [
    { id: 0, name: 'Sort', },
    { id: 1, name: 'Low', },
    { id: 2, name: 'Medium', },
    { id: 3, name: 'High', },
    { id: 4, name: 'Critical', }
]



function Support() {
    const [selected, setSelected] = useState(filter[0])
    //const [statusSelected, setStatusSelected] = useState(status[0])
    const [prioritySelected, setPrioritySelected] = useState(filter[1])
    const [searchText, setSearchText] = useState(null)
    
    
    // date picker
    const [dateValue, setDateValue] = useState({
        startDate: null,
        endDate: null
    });

   
   
    return (
        <Layout>
            <SupportProvider>
               
            <ProductList />
                <main>
                    <div className="mx-auto max-w-7xl my-2 px-4 lg:px-0">
                        {/* <div className='flex justify-center mb-6'>
                            <nav className="flex divide-x divide-gray-200 rounded-lg shadow overflow-hidden">
                                <button
                                    className="text-gray-50 hover:text-gray-50 group relative min-w-0 flex-1 overflow-hidden bg-red-500 hover:bg-red-600 px-8 py-4 whitespace-nowrap text-center text-sm font-bold uppercase focus:z-10"
                                >
                                    <span>All Tickets</span>
                                    <span
                                        aria-hidden="true"
                                        className="bg-red-500 absolute inset-x-0 bottom-0 h-0.5"
                                    />
                                </button>
                                <button
                                    className="text-gray-500 hover:text-gray-500 group relative min-w-0 flex-1 overflow-hidden bg-gray-50 hover:bg-gray-100 px-8 py-4 whitespace-nowrap text-center text-sm font-bold uppercase focus:z-10"
                                >
                                    <span>My Tickets</span>
                                    <span
                                        aria-hidden="true"
                                        className="absolute inset-x-0 bottom-0 h-0.5"
                                    />
                                </button>
                            </nav>
                        </div> */}
                        <div className='text-gray-50 bg-white rounded-2xl shadow-lg'>
                            <div className="mx-auto p-6 bg-slate-50 rounded-t-2xl">
                                <div className='flex flex-wrap gap-2 items-center'>
                                    <div className='relative flex-1'>
                                        <input
                                            name="search"
                                            type="text"
                                            placeholder='Search tickets...'
                                            className="block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                            defaultValue={searchText}
                                            onChange={(e)  => setSearchText(e.target.value)}
                                        />
                                    </div>
                                    <div className='border border-gray-300 rounded-md w-100'>
                                        <Datepicker
                                            primaryColor={"red"}
                                            value={dateValue}
                                            onChange={(newValue) => {
                                                setDateValue((current) => {
                                                    const toKey = (value) => {
                                                        if (!value) return "";
                                                        const time = new Date(value).getTime();
                                                        return Number.isNaN(time) ? String(value) : String(time);
                                                    };
                                                    if (
                                                        toKey(current?.startDate) === toKey(newValue?.startDate) &&
                                                        toKey(current?.endDate) === toKey(newValue?.endDate)
                                                    ) {
                                                        return current;
                                                    }
                                                    return newValue;
                                                });
                                            }}
                                            showShortcuts={true}
                                            placeholder="Filter by date"
                                        />
                                    </div>
                                    {/* <Listbox value={selected} onChange={setSelected}>
                                        <div className="relative w-32">
                                            <ListboxButton className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-2 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                                <span className="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                                                    <span className="block truncate">{selected.name}</span>
                                                </span>
                                                <ChevronUpDownIcon
                                                    aria-hidden="true"
                                                    className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                                />
                                            </ListboxButton>

                                            <ListboxOptions
                                                transition
                                                className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
                                            >
                                                {filter.map((person) => (
                                                    <ListboxOption
                                                        key={person.id}
                                                        value={person}
                                                        className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-indigo-600 data-[focus]:text-white data-[focus]:outline-none"
                                                    >
                                                        <div className="flex items-center">
                                                            <span className="ml-3 block truncate font-normal group-data-[selected]:font-semibold">
                                                                {person.name}
                                                            </span>
                                                        </div>

                                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600 group-[&:not([data-selected])]:hidden group-data-[focus]:text-white">
                                                            <CheckIcon aria-hidden="true" className="size-5" />
                                                        </span>
                                                    </ListboxOption>
                                                ))}
                                            </ListboxOptions>
                                        </div>
                                    </Listbox> */}
                                </div>
                            </div>

                            <TicketTabs />
                            <div className='mx-auto'>
                                <div className='bg-slate-200 sm:flex sm:gap-px sm:divide-y-0'>
                                    <Tickets searchText={searchText} dateValue={dateValue}/>                                    
                                    <TicketDetails />
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </SupportProvider>
        </Layout >
    )
}

export default React.memo(Support);
